/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ played: NonNullable<unknown>, total: NonNullable<unknown> }} Scenarioplayedcount2Inputs */



/**
* | output |
* | --- |
* | "Played {played} of {total}" |
*
* @param {Scenarioplayedcount2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const scenarioplayedcount2 = /** @type {((inputs: Scenarioplayedcount2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scenarioplayedcount2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Played ${i?.played} of ${i?.total}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Jugados ${i?.played} de ${i?.total}`)
	return /** @type {LocalizedString} */ (`Сыграно ${i?.played} из ${i?.total}`)
});
export { scenarioplayedcount2 as "scenarioPlayedCount" }